import $ from 'jquery';
import demoComponent from './demo-component/demo-component'
import documentCardComponent from './document-card/document-card'
import sourceAvatar from './source-avatar/source-avatar'
import 'babel-polyfill'

const componentsModule = angular.module('ngHaakon.components', [
    'MW.Framework.ContentBehaviorService',
    'MW.Framework.AnalyticsService',
    'MW.Framework.DialogService',
    'MW.Framework.GeoService',
    'MW.Framework.LinkyHtmlFilter',
    'MW.Framework.MediaTypeAvatar',
    'MW.Framework.MediaTypeService',
    'MW.Framework.MediaTypeIcon',
    'MW.Framework.TagService',
    'MW.Framework.TextFilters',
    'MW.Framework.TranslateFilter',
    'MW.Framework.TranslationService',
    'MW.Framework.FeatureToggleService',
    'MW.Framework.UIFilters',
    'Configuration',
    'EnvironmentConfiguration',
    'MW.Framework.UriService',
    'ngSanitize',
    'UI.Dropdown',
    'MW.Framework.FallbackSrc',
    'MW.Framework.HagarSrc'
    ]);


demoComponent(componentsModule)
documentCardComponent(componentsModule)
sourceAvatar(componentsModule)



// WEBPACK FOOTER //
// ./source/components/index.js